export default {
  item: {
    myResources: 'Mis recursos',
    schoolsGroupResources: 'Recursos de la red'
  }
}

export const en = {
  item: {
    myResources: 'My resources',
    schoolsGroupResources: 'Network resources'
  }
}

export const ca = {
  item: {
    myResources: 'Els meus recursos',
    schoolsGroupResources: 'Recursos de la xarxa'
  }
}
